import { Box, Divider, Typography } from '@mui/material';
import { paths } from '@common/types';
import { PatientInfo, ProviderInfo, TaskInfo } from './components';
import { t } from 'i18next';
import { StatusBanner } from '@components';

interface IOverviewProps {
  task: paths[`/task/{task_id}`]['get']['responses']['200']['content']['application/json'];
  isFormDisabled: boolean;
  lockedBy: {
    name: string;
    role: string;
  };
  handleUnlockLockedTask: () => void;
  isUnlockInProgress: boolean;
  setIsSavingTask: (isSaving: boolean) => void;
  isUnlockDisabled: boolean;
}

export const Overview = ({
  task,
  isFormDisabled,
  lockedBy,
  handleUnlockLockedTask,
  isUnlockInProgress,
  setIsSavingTask,
  isUnlockDisabled,
}: IOverviewProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        overflow: 'auto',
        alignItems: 'center',
      }}
    >
      {isFormDisabled && lockedBy.name && (
        <StatusBanner
          text={t('common.lockedByBanner.message', {
            name: lockedBy.name,
            role: t(`roles.${lockedBy.role}`),
          })}
          variant={'warning'}
          action={handleUnlockLockedTask}
          actionText={t('common.lockedByBanner.unlock')}
          actionLoading={isUnlockInProgress}
          actionDisabled={isUnlockDisabled}
        />
      )}
      <Typography
        variant='body2'
        sx={{
          pb: 2,
          wordWrap: 'break-word',
          whiteSpace: 'pre-line',
          width: '100%',
          textAlign: 'left',
        }}
      >
        {task.description}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          gap: '1rem',
          flexDirection: 'column',
        }}
      >
        <TaskInfo
          setIsSavingTask={setIsSavingTask}
          task={task}
          isDisabled={isFormDisabled || !task.has_write_permission}
        />
        <Divider orientation='horizontal' sx={{ p: 0 }} />
        <PatientInfo task={task} />
        {task.provider_type !== 'Unknown' && (
          <>
            <ProviderInfo task={task} />
          </>
        )}
      </Box>
    </Box>
  );
};
